
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { UserPrintersData } from '@/models/main';
import PrintBtn from '@/components/btns/PrintBtn.vue';
import { sendError } from '@/helpers/sentry';

@Component({
  components: {
    PrintBtn,
  },
})
export default class PreviewJobDialogBody extends Vue {
  @Prop(Array) public printers: UserPrintersData[];
  @Prop(Function) public printRequest: (printerId: number) => Promise<AxiosResponse>;
  @Prop(Function) public close: () => void;

  public selectedPrinterId = NaN;
  public loading = false;
  public error = '';

  @Watch('printers', { immediate: true })
  private watchPrinters(printers: UserPrintersData[]) {
    if (printers.length === 1) {
      this.selectedPrinterId = printers[0].id;
    }
  }

  public handleBtnClick() {
    this.loading = true;
    this.error = '';
    this.printRequest(this.selectedPrinterId)
      .then(res => {
        if (res.status === 204) {
          // The request went through, there was simply nothing to put on a label
          this.error = 'Nothing to print';
        } else if (res.status === 200) {
          this.close();
        } else {
          throw new Error(`res.status: ${res.status}`);
        }
      })
      .catch(err => {
        this.error = 'Error';
        sendError(err, 'PrinterListBody');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  handleTrClick(printerId: number) {
    this.selectedPrinterId = printerId;
  }
}
